import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TeacherAdmin from "../../components/Teacher/Tabs/TeacherAdmin";
import TeacherResultOverview from "../../components/Teacher/Tabs/TeacherResultOverview";
import TeacherDocuments from "../../components/Teacher/Tabs/TeacherDocuments";
import TeacherCourses from "../../components/Teacher/Tabs/TeacherCourses";
import { Row, Col, Card, CardBody } from "reactstrap";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import {
  GetProgramById,
  GetTeacherInformation,
  GetSchoolDataBySchoolId,
} from "../../actions/teacherQueries";
import TabNavSelector from "../../components/Teacher/Tabs/TabNavSelector";
import APL from "../../components/APL/APL";
import useTeacherNavStore from "../../stores/useTeacherNavStore";

export default function TeacherProgram() {
  const navigate = useNavigate();
  const { programId } = useParams();
  const [studentsInProgram, setStudentsInProgram] = useState([]);
  const programInfo = GetProgramById(programId);
  const teacherInfo = GetTeacherInformation();

  const customerId = teacherInfo?.data?.customer?.id ?? null;
  const schoolInfo = GetSchoolDataBySchoolId(customerId);

  const tab = useTeacherNavStore((state) => state.tab);

  useEffect(() => {
    if (!teacherInfo.isPending && teacherInfo.data) {
      const currentProgram = teacherInfo.data.programmes.find(
        (program) => program.id === Number(programId)
      );
      if (!currentProgram) {
        navigate("/teacher");
        return;
      }
      const tempStudentsInProgram = [];
      currentProgram.classes.forEach((cl) => {
        tempStudentsInProgram.push(...cl.students);
      });
      setStudentsInProgram(tempStudentsInProgram);
    }
  }, [programId, navigate, teacherInfo.data, teacherInfo.isPending]);

  if (programInfo.isPending || teacherInfo.isPending || schoolInfo.isPending) {
    return <Pacmanloader />;
  }

  const renderTab = () => {
    switch (tab) {
      case 1:
        return (
          <TeacherAdmin
            level="Program"
            programInfo={programInfo}
            teacherInfo={teacherInfo}
            schoolInfo={schoolInfo}
          />
        );
      case 2:
        return (
          <TeacherCourses
            programId={Number(programId)}
            teacherInfo={teacherInfo}
            objId={"program" + programId}
            displayDocuments={false}
            level="Program"
          />
        );
      case 3:
        return (
          <TeacherResultOverview
            level="Program"
            programId={Number(programId)}
          />
        );
      case 5:
        return <TeacherDocuments level="Program" />;
      case 7:
        return (
          <APL
            level="Program"
            students={studentsInProgram}
            levelName={programInfo.data.name}
            objId={programInfo.data.id}
            schoolId={teacherInfo.data.customer.id}
            programId={programId}
            teacherInfo={teacherInfo}
          />
        );
      default:
        return <TeacherAdmin level="Program" />;
    }
  };
  return (
    <div className="teacher-container animated fadeIn">
      <Row>
        <Col lg={12}>
          <Card>
            <TabNavSelector level="Program" objId={programId} />
            <CardBody className="responsive-card">{renderTab()}</CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
